import axios, { AxiosResponse } from "axios";
import { defaultHeaders } from "../config/config";
import { BIOMETRICS_URL } from "../config/const";
import { StandardResponse } from "../type";
import { IDemandCandidateResult } from "../store/models/BiometricDemandModel";

const instance = axios.create({
  baseURL: BIOMETRICS_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const CANDIDATE_URL = "/BiometricDemand/Candidate";
const FLOW_TYPE_URL = "/BiometricDemand/FlowType";

/**
 * Gets the candidate associated with a valid Demand for the authenticated user
 * @returns {StandardResponse<IDemandCandidateResult>} Candidate data
 */
export const getDemandCandidate = async (): Promise<StandardResponse<IDemandCandidateResult>> => {
  try {
    const response: AxiosResponse<StandardResponse<IDemandCandidateResult>> = await instance.get(
      CANDIDATE_URL,
      defaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Determines whether the authenticated user's company should use Standard (0) or Demand (1) biometric flow
 * @returns {StandardResponse<number>} 0 for Standard, 1 for Demand
 */
export const getFlowType = async (): Promise<StandardResponse<number>> => {
  try {
    const response: AxiosResponse<StandardResponse<number>> = await instance.get(
      FLOW_TYPE_URL,
      defaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

